"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _validate = require("@/utils/validate");

var _SocialSignin = _interopRequireDefault(require("./components/SocialSignin"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'Login',
  components: {
    SocialSign: _SocialSignin.default
  },
  data: function data() {
    var validateName = function validateName(rule, value, callback) {
      if (value) {
        callback(new Error('正しいユーザーIDを入力してください'));
      } else {
        callback();
      }
    };

    var validatePassword = function validatePassword(rule, value, callback) {
      if (value.length < 4) {
        callback(new Error('パスワードは４桁以上で入力してください'));
      } else {
        callback();
      }
    };

    return {
      loginForm: {
        id: '',
        company_id: '',
        password: ''
      },
      loginRules: {
        id: [{
          required: true,
          trigger: 'blur',
          validator: validateName
        }],
        password: [{
          required: true,
          trigger: 'blur',
          validator: validatePassword
        }],
        company_id: [{
          required: true,
          trigger: 'blur',
          validator: validateName
        }]
      },
      passwordType: 'password',
      capsTooltip: false,
      loading: false,
      showDialog: false,
      redirect: undefined,
      otherQuery: {},
      validateName: function validateName(rule, value, callback) {
        if (value.trim() === '' || value === null) {
          callback(new Error(rule.colname + 'を入力してください。'));
        } else if (!(0, _validate.checkIsNumber)(value)) {
          callback(new Error('半角数字を入力してください。'));
        } else if (value.length > rule.maxLen) {
          callback(new Error(rule.colname + 'は' + rule.maxLen + '桁の数値を入力してください。'));
        } else {
          callback();
        }
      },
      validatePassword: function validatePassword(rule, value, callback) {
        if (value.trim() === '' || value === null) {
          callback(new Error(rule.colname + 'を入力してください。'));
        } else if (value.length > rule.maxLen) {
          callback(new Error(rule.colname + 'は' + rule.maxLen + '桁の数値を入力してください。'));
        } else {
          callback();
        }
      }
    };
  },
  watch: {
    $route: {
      handler: function handler(route) {
        var query = route.query;

        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true
    }
  },
  created: function created() {// window.addEventListener('storage', this.afterQRScan)
  },
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$store.dispatch('user/logout');

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  destroyed: function destroyed() {// window.removeEventListener('storage', this.afterQRScan)
  },
  methods: {
    checkCapslock: function checkCapslock() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          shiftKey = _ref.shiftKey,
          key = _ref.key;

      if (key && key.length === 1) {
        if (shiftKey && key >= 'a' && key <= 'z' || !shiftKey && key >= 'A' && key <= 'Z') {
          this.capsTooltip = true;
        } else {
          this.capsTooltip = false;
        }
      }

      if (key === 'CapsLock' && this.capsTooltip === true) {
        this.capsTooltip = false;
      }
    },
    showPwd: function showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = '';
      } else {
        this.passwordType = 'password';
      }
    },
    handleLogin: function handleLogin() {
      var _this = this;

      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          _this.loading = true;

          _this.$store.dispatch('user/login', _this.loginForm).then(function () {
            if (_this.$store.getters.redirect.length > 0) {
              if (_this.$store.getters.redirect === 'non_active') {
                _this.loading = false;
              } else {
                _this.redirect = _this.$store.getters.redirect;

                _this.$router.push({
                  path: _this.redirect || '/',
                  query: _this.otherQuery
                });

                _this.loading = false;
              }
            } else {
              _this.loading = false;
            }
          }).catch(function (error) {
            _this.$message({
              type: 'error',
              message: "".concat(error),
              duration: 5000
            });

            _this.loading = false;
          });
        } else {
          return false;
        }
      });
    },
    getOtherQuery: function getOtherQuery(query) {
      return Object.keys(query).reduce(function (acc, cur) {
        if (cur !== 'redirect') {
          acc[cur] = query[cur];
        }

        return acc;
      }, {});
    } // afterQRScan() {
    //   if (e.key === 'x-admin-oauth-code') {
    //     const code = getQueryObject(e.newValue)
    //     const codeMap = {
    //       wechat: 'code',
    //       tencent: 'code'
    //     }
    //     const type = codeMap[this.auth_type]
    //     const codeName = code[type]
    //     if (codeName) {
    //       this.$store.dispatch('LoginByThirdparty', codeName).then(() => {
    //         this.$router.push({ path: this.redirect || '/' })
    //       })
    //     } else {
    //       alert('第三方登录失败')
    //     }
    //   }
    // }

  }
};
exports.default = _default;